// extracted by mini-css-extract-plugin
module.exports = {"container":"DesktopVerticalTabMenu_container__Qy_UH"};